import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {User} from "../../model/user";

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit {
  mobile: boolean = false;
  currentUrl: string;
  user: User;
  constructor() {  this.currentUrl = window.location.href; }
  @Input() active: boolean;
  @Input() closeable: boolean = true;
  @Input() width: number = 800;
  @Output() modalClosed = new EventEmitter();
  @ViewChild('scrollBar') scrollBar: ElementRef;

  ngOnInit(): void {
    if (window.screen.width <= 1000) { // 768px portrait
      this.mobile = true;
    }
  }

  closeModal(){
    this.active = false;
    this.modalClosed.emit();
    document.getElementById("modal-comp").classList.remove("is-active");
  }

    /**
     * scrolls to the top of the component
     */
    public scrollToTop(): void {
        this.scrollBar.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
    }



}
